
<template>
  <div class="van-doc-demo-block__card">
    <router-link
      tag="div"
      :to="{ name: 'details',query:{ app }}"
      class="van-hairline--bottom"
    >
      <div
        role="button"
        tabindex="0"
        class="van-cell van-cell--clickable"
      >
        <div class="van-cell__title">
          <span class="title">营业资质</span>
        </div>
        <i class="van-icon van-icon-arrow van-cell__right-icon"></i>
      </div>
    </router-link>
    <router-link
      tag="div"
      :to="{path:'getRuleContent',query:{type:ifCity ? '47' : '26', app,source:'expert',time:new Date().getTime()}}"
      class="van-hairline--bottom"
    >
      <div
        role="button"
        tabindex="0"
        class="van-cell van-cell--clickable"
      >
        <div class="van-cell__title">
          <span class="title">注册协议</span>
        </div>
        <i class="van-icon van-icon-arrow van-cell__right-icon"></i>
      </div>
    </router-link>
    <router-link
      tag="div"
      :to="{path:'getRuleContent',query:{type:ifCity ? '49' : '25', app,source:'expert',time:new Date().getTime()}}"
      class="van-hairline--bottom"
    >
      <div
        role="button"
        tabindex="0"
        class="van-cell van-cell--clickable"
      >
        <div class="van-cell__title">
          <span class="title">隐私政策协议</span>
        </div>
        <i class="van-icon van-icon-arrow van-cell__right-icon"></i>
      </div>
    </router-link>
    <router-link
      tag="div"
      :to="{path:'messageShare',query:{ app,time:new Date().getTime()} }"
      class="van-hairline--bottom"
    >
      <div
        role="button"
        tabindex="0"
        class="van-cell van-cell--clickable"
      >
        <div class="van-cell__title">
          <span class="title">第三方信息数据共享</span>
        </div>
        <i class="van-icon van-icon-arrow van-cell__right-icon"></i>
      </div>
    </router-link>
    <router-link
      tag="div"
      :to="{path:'messageList',query:{ app,time:new Date().getTime()} }"
      class="van-hairline--bottom"
    >
      <div
        role="button"
        tabindex="0"
        class="van-cell van-cell--clickable"
      >
        <div class="van-cell__title">
          <span class="title">个人信息收集清单</span>
        </div>
        <i class="van-icon van-icon-arrow van-cell__right-icon"></i>
      </div>
    </router-link>
    <!-- 下边线 -->
    <div
      tabindex="0"
      class="van-cell "
    >
      <div class="van-cell__title">
        <span></span>
      </div>
    </div>
  </div>

</template>
<script>
export default {
  data() {
    return {
      ifCity:false, // 是否是行家
      app:false, // 是否是app
    };
  },
  methods:{
    GetQueryString(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      var r = window.location.href.split('?')[1] ? window.location.href.split('?')[1].match(reg) : null;
      if (r != null) return decodeURIComponent(r[2]);
      return null;
    }
  },
  mounted(){
    let that = this;
    // 如果查询字符串带有source，并且等于2，则是用户端进入
    this.GetQueryString('source') == 2 ? this.ifCity = true : '';
    var ua = window.navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
          //微信环境
          wx.miniProgram.getEnv(function(res) {
            if (res.miniprogram) {
                that.app = false
            } else {
                //非小程序环境下逻辑
            }
          });
      } else {
        this.app = true;
      }
  },
};
</script>
<style lang="scss" scoped>
.top_content {
  padding: 0 12px;
  .list {
    // height: 19px;
    display: flex;
    font-size: 14px;
    padding: 15px 0 15px 0;
    .right_title {
      flex: 2;
      color: #999999;
    }
    .left_content {
      // display: inline-block;
      flex: 8;
      color: #333333;
      margin-left: 19px;
    }
    .ellipsis {
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
    }
  }
}
.title {
  color: #333333;
  font-size: 15px;
}
.bottom_pic {
  padding: 0 12px;
  .list {
    height: 19px;
    font-size: 14px;
    padding: 15px 0 15px 0;
    .right_title {
      display: inline-block;
      color: #999999;
    }
  }
  .qualification {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    .qualification_top {
      padding: 0 10px 10px 0;
      width: 160px;
      height: 133px;
    }
    .qualification_bottom {
      padding: 0 10px 10px 0;
      width: 150px;
      height: 133px;
    }
    img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>